var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShoppingCart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 30 27.773",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "shopping-cart",
    transform: "translate(-0.15 -0.15)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2756",
    "data-name": "Group 2756",
    transform: "translate(0.15 0.15)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_14",
    "data-name": "Ellipse 14",
    cx: 2.544,
    cy: 2.544,
    r: 2.544,
    transform: "translate(9.912 22.685)",
    fill: "#00246a"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_15",
    "data-name": "Ellipse 15",
    cx: 2.544,
    cy: 2.544,
    r: 2.544,
    transform: "translate(21.359 22.685)",
    fill: "#00246a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2087",
    "data-name": "Path 2087",
    d: "M24.567,21.29H12.222a3.6,3.6,0,0,1-3.6-2.9L6.511,7.815q-.012-.048-.019-.1L5.407,2.3H1.226a1.076,1.076,0,1,1,0-2.152H6.289a1.076,1.076,0,0,1,1.055.865L8.438,6.479H29.074a1.076,1.076,0,0,1,1.057,1.278l-2.025,10.62,0,.008A3.6,3.6,0,0,1,24.567,21.29ZM12.213,19.137H24.566a1.454,1.454,0,0,0,1.427-1.169l1.781-9.338H8.869l1.868,9.333a1.455,1.455,0,0,0,1.456,1.173Z",
    transform: "translate(-0.15 -0.15)",
    fill: "#00246a"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShoppingCart);
export default __webpack_public_path__ + "static/media/ShoppingCart.846911143990a47c187c0b7b3f699ab0.svg";
export { ForwardRef as ReactComponent };